var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`nav-link text-uppercase table-section ${_vm.active ? 'active' : ''}`,on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }